
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
@Component({})
export default class LumpAFEBudget extends Vue {
    @Prop({ default: () => [] })
    rows!: Array<any>;
    @Prop({ default: () => [] })
    activeProjectConversionFactor!: number;
    @Prop({ default: () => [] })
    lineSplit!: number;
    @Prop({ default: () => [] })
    disabled!: boolean;
    @Prop({ default: () => [] })
    projectYear!: number;
    
    forceReload = 0;

    updateLineSum(departmentId: any, proposedAFEBudget: number, approvedAFEBudget: number, realignedAFEBudget: number, afeCost: number) {
      this.$emit('lineValueChanged', {departmentId, proposedAFEBudget, approvedAFEBudget, realignedAFEBudget, afeCost})
    }

    proposedCalculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.proposedAFEBudget || 0), 0);
    }
    proposedCalculateTotalK$(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.proposedAFEBudget * this.lineSplit) || 0), 0);
    }
    proposedCalculateTotalKNGN(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.proposedAFEBudget * (1 - this.lineSplit) * this.activeProjectConversionFactor) || 0), 0);
    }

    approvedCalculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.approvedAFEBudget || 0), 0);
    }
    approvedCalculateTotalK$(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.approvedAFEBudget * this.lineSplit) || 0), 0);
    }
    approvedCalculateTotalKNGN(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.approvedAFEBudget * (1 - this.lineSplit) * this.activeProjectConversionFactor) || 0), 0);
    }

    reAllignedCalculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.realignedAFEBudget || 0), 0);
    }
    reAllignedCalculateTotalK$(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.realignedAFEBudget * this.lineSplit) || 0), 0);
    }
    reAllignedCalculateTotalKNGN(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.realignedAFEBudget * (1 - this.lineSplit) * this.activeProjectConversionFactor) || 0), 0);
    }

    mounted() {
      this.forceReload += 1;
    }
}
